import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Label } from 'reactstrap';
import { parse } from 'query-string';
import api from '../../../../services/ApiService';
import { FormattedMessage } from 'react-intl';
import { object, func } from 'prop-types';
import { startSetStreams, setStreamsFilter } from '../../../../actions/streams';
import Select from '../../../../components/common/Select';

// import OffersFilter from '../Offers/OffersFilter';
import { debounce } from '../../../../utils/utils';
import Search from '../../../../components/common/Search';

import Filter from '../../../../components/Filter/Filter/Filter';

export class FlowsListFilters extends Component {
  static propTypes = {
    settings: object.isRequired,
    onSearch: func.isRequired,
  };

  constructor(props) {
    super(props);

    const parsedParams = parse(window.location.search);

    const { settings } = props;

    const options = settings && settings.offers ? this.getPreparedOffers(settings.offers) : [];

    this.state = {
      query: parsedParams.title ? parsedParams.title : '',
      offerId: [],
      options,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { offerId } = parse(window.location.search);
    if (nextProps.settings && offerId && offerId !== this.state.offerId) {
      this.setState(() => ({
        offerId: offerId.split(','),
      }));
    }
    if (nextProps) {
      const { filters } = nextProps;

      if (!filters) {
        this.handleFiltersReset();
      }
    }
  }

  handleFiltersReset = () => {
    this.onFilterReset();

    this.setState(() => ({
      query: '',
    }));

    this.props.setStreamsFilter({});
  }

  handleChange = e => {
    const query = e.target.value;

    this.setState(
      () => ({ query }),
      () => {
        const { query } = this.state;
        if (this.props.notApplyOnChange) {
          this.props.getQuery(query);
        }
        else {
          this.props.onSearch(query);
        }
      },
    );
  };

  // handleOfferChange = offerId => {
  //   this.props.updateLocation({ offerId, page: 0 });
  //   this.setState({ offerId });
  //   const params = parse(window.location.search);
  //   this.props.onChange({ ...params, offerId, page: 0 });
  // };

  onFilterChange = offers => {
    const filtered = offers.filter(offer => offer.checked);
    if (!filtered.length) {
      return this.onFilterReset();
    }
    const offerId = filtered.map(item => item.id);
    this.setState({ offerId: offerId.map(String) });
    const offerString = offerId.join(',');
    this.props.updateLocation({ offerId: offerString, page: 0 });
    const params = parse(window.location.search);
    if (this.props.notApplyOnChange) {
      this.props.saveOffersFilters({ ...params, offerId: offerString, page: 0 });
    } else {
      this.props.onChange({ ...params, offerId: offerString, page: 0 });
    }
  };

  onFilterReset = () => {
    this.setState(
      () => ({
        offerId: [],
      }),
      () => {
        this.props.updateLocation({ page: 0, offerId: null });
        const params = parse(window.location.search);
        this.props.onChange({ ...params, page: 0 });
      },
    );
  };

  getPreparedOffers = () => {
    const {
      settings: { offers },
    } = this.props;

    if (!offers) {
      return [];
    } else {
      const offerIds = Object.keys(offers);
      if (!offerIds) {
        return [];
      } else {
        return offerIds.map(id => ({ ...offers[id], id }));
      }
    }
  };

  getOptions = debounce((input, cb) => {
    const offers = this.getPreparedOffers(this.state.options);
    const q = input.trim();
    const params = {};

    if (q.length > 2) {
      params.title = q;
    } else {
      cb(null, { options: this.prepareOptions([...offers]) });
    }
    api.offers
      .getList(params)
      .then(data => data.items)
      .then(options => cb(null, { options: this.prepareOptions([...options, ...offers]) }));
    //.catch(error => cb(error, null));
  }, 500);

  prepareOptions = options =>
    options.map(option => ({
      value: option.id,
      label: option.title,
    }));

  setItemStatus = (items, selectedItems) => {
    return items.map(item => {
      return {
        ...item,
        checked: selectedItems.includes(item.id),
      };
    });
  };

  getItems = () => {
    const offers = this.getPreparedOffers();
    const { offerId } = this.state;
    return this.setItemStatus(offers, offerId);
  };

  render() {
    const { query, offerId } = this.state;
    const offers = this.getPreparedOffers();
    const { withLabels } = this.props;

    return (
      <Row className="offer-filters">
        {offers && (
          <Fragment>
            <Col xs='12' className='mb-2 row'>
              {withLabels && (
                <Label for='flow-search'>
                  <FormattedMessage id="flows.table.title.theme_4" defaultMessage='Name' />:
                </Label>
              )}
              <Search
                id='flow-search'
                onChange={this.handleChange}
                query={query}
                placeholder="flows.enter-flow-name"
                defaultMessage="123"
              />
            </Col>

            <Col xs='12' className='row'>
              <FormattedMessage id="flows.table.offers.theme_4" defaultMessage="Offers">
                {label => (
                  <Fragment>
                    {withLabels && <Label className="filter-label">{label}:</Label>}
                    <Filter
                      name="offerId"
                      defaultLabel={label}
                      items={this.getItems()}
                      search
                      activeParamsNumber={offerId.length}
                      onFilterChange={this.onFilterChange}
                      onFilterReset={this.onFilterReset}
                      mobileModal
                    />

                  </Fragment>
                )}
              </FormattedMessage>
              {/* <Button color="primary" size="sm" onClick={this.onFilterApply}>
                  <FormattedMessage id="main.search" defaultMessage="Search" />
                </Button> */}
            </Col>
          </Fragment>
        )}
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.streams.settings,
  filters: state.streams.filters,
});

const mapDispatchToProps = dispatch => ({
  startSetStreams: () => dispatch(startSetStreams()),
  setStreamsFilter: () => dispatch(setStreamsFilter()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FlowsListFilters);
